import $ from 'jquery'
import Screen from './screen'
import { isActive, isOpen, isShow, breakpointMD } from '../_variables'

export default class ModalJs {
  init() {
    const screen = new Screen()
    let dragging = false;
    let event = 'click';
    
    $("body").on("touchmove", function(){
      dragging = true;
    });
    
    $("body").on("touchend", function(){
      if (dragging)
          return;
    
      // wasn't a drag, just a tap
      // more code here
    
    });
    
    $("body").on("touchstart", function(){
      dragging = false;
    });

    $(function () {
      jsModal()
    })


    /* !jsModal
    ---------------------------------------------------------- */
    const jsModal = function () {
      const $btnOpen = $('.js-open-modal');
      const $popUp = $('.js-modal');
      const $btnClose = $('.js-close-popup');
      const $modalBG = $('.mld-bg');
      const $modalWrap = $('.mld-wrap');
      const isActive = '-is-active';
      const isModal = '-is-modal-open';

      if($('body').hasClass(isModal)) {
        $modalBG.addClass(isActive)
        $modalWrap.addClass(isActive)
        screen.lock()
      } else {
        $modalBG.removeClass(isActive)
        $modalWrap.removeClass(isActive)
        screen.unlock()
      }

      // $(document).on('click touchend', function (e) {
      //   if($(e.target).closest('.c-header').length === 0
      //     && $(e.target).closest('.c-popup-panel').length === 0) {

      //     if(!dragging){
      //       if($popUp.hasClass(isActive)){
      //         $popUp.removeClass(isActive)
      //         $('body').removeClass(isModal)
      //         screen.unlock()
      //       }
      //     }
      //   }
      // });

      $('.js-close-popup').on('click', () => {
        $popUp.removeClass(isActive)
        $('body').removeClass(isModal)
        screen.unlock()
      })
    };

  }
}